import React, { useState, useEffect } from "react";

import {
    Chip,
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Slide,
    Typography,
    Avatar,
} from "@material-ui/core";

import { uri } from "../../../help/Api";
import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesContainers,
    useStylesDPM,
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../St/comps/UseStyle";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import moment from "moment";
import axios from "axios";
import { insh, sto, wsto } from "../../../Context/InshData";
import { useStylesBA } from "../../../St/comps/UseStyle";
import { getLS } from "../../../utils/useLS";
import toast from "react-hot-toast";

import EmployeesSalaryForm from "./EmployeesSalaryForm";
import EmployeesSalaryAppbar from "./EmployeesSalaryAppbar";
import EmployeeSalarySearch from "./EmployeeSalarySearch/EmployeeSalarySearch";
import { GetItemFromOptions } from "../../../services/global-services";
import EmployeesSalaryProfment from "./EmployeesSalaryProfe";
import GroupIcon from "@material-ui/icons/Group";
import { style } from "../../../Fronts/Menues/st/cStyle";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { reFormatDate } from "../../../utils/utils";
import { number } from "yup";
import DeleteConfirmDialog from "../../../components/DeleteConfirmDialog";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: "#f1f1fa",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: "#f1f1fa",
        borderColor: "#4a82b9",
    },
    avatar: {
        backgroundColor: "#4a82b9",
        color: "#fff",
        height: 46,
        width: 46,
        marginTop: -5,
    },
    icon: {
        height: 32,
        width: 32,
    },
}));

export default function EmployeesSalary(props) {

    const { AutoOptions, branch, setBranch } = props;
    const clasess = useStyles();
    const valuebranch = GetItemFromOptions(sto.branchi, AutoOptions.Branches ?? []);
    const [costCenters, setCostCenters] = useState(() => {
        return [{ id: -1, name: "بدون" }, ...AutoOptions?.center ?? []];
    });
    const months = [
        { id: 1, name: 'يناير' },
        { id: 2, name: 'فبراير' },
        { id: 3, name: 'مارس' },
        { id: 4, name: 'أبريل' },
        { id: 5, name: 'مايو' },
        { id: 6, name: 'يونيو' },
        { id: 7, name: 'يوليو' },
        { id: 8, name: 'أغسطس' },
        { id: 9, name: 'سبتمبر' },
        { id: 10, name: 'أكتوبر' },
        { id: 11, name: 'نوفمبر' },
        { id: 12, name: 'ديسمبر' },
    ];

    const years = Array.from({ length: 50 }, (_, i) => {
        const year = new Date().getFullYear() - i;
        return { id: year, name: year.toString() };
    });
    const datas = {
        id: 0,
        no: AutoOptions.other.lastid,
        date: moment(new Date()).format('YYYY-MM-DD'),
        month: months[0].id,
        year: years[0].id,
        branch: sto.branchi,
        emp: "",
        tot_salary: 0,
        salary_add: 0,
        salary_sub: 0,
        salary_net: 0,
        emp_resp: AutoOptions?.Employees[0].id,
        notes: "",
        IS_Deleted: "",
        center: costCenters[0].id,
        safe_bank_id: AutoOptions.Stocks[0].id,
        type: 1,
        rest_id: "",
        rest_notes: "",
        salary_prof: 0,
        date_prof: moment(new Date()).format('YYYY-MM-DD'),
        update_user: "",
        update_date: "",
        tot_advances: 0,
    };

    const ValueSalary = {
        salary_basic: 0,
        house: 0,
        food: 0,
        travel: 0,
        medical: 0,
        salary_add: 0,
        salary_other: 0,
        rest_notes: "",
        date_prof: moment(new Date()).format('YYYY-MM-DD'),
    };
    const inshValueAuto = {
        branch: valuebranch,
        emp: {},
        emp_resp: AutoOptions?.Employees[0],
        center: costCenters[0],
        safe_bank_id: AutoOptions.Stocks[0],
        month: months[0],
        year: years[0],
        type: { name: "type", value: 1 }
    };

    const [params, setParams] = useState({
        ...datas,
        branch: AutoOptions.Branches[0].id,
    });


    const [valueAutos, setValueAutos] = useState(inshValueAuto);
    const [salaryEmpData, setSalaryEmpData] = useState(ValueSalary);
    const [addProfSalary, setAddProfSalary] = useState(true);
    const [advances, setAdvances] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const clashd = useStylesHed();

    const clasBA = useStylesBA();

    const clasCAB = useStylesCAB();
    const locSto = getLS("sto", {});
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openButtonsSearch, setOpenButtonsSearch] = useState(false);
    const [procIdSearch, setProcIdSearch] = useState(0);

    const [showPic, setShowPic] = useState(false);
    const [or, setOr] = useState(insh.Or);

    const inshParm = { itake: 20, symple: "", groupSearch: null };
    const [parm, setParm] = useState(inshParm);

    const timer = React.useRef();
    const [uiElement, setUiElement] = useState({});

    const [transition, setTransition] = React.useState(undefined);


    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });

    const [style, setStyle] = useState({});

    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const [prevent, setPrevent] = useState(true);





    // const ust_o = (updatedData) => {
    function usto(olddata) { }

    const [openSearchMdl, setOpenSearchMdl] = useState(false);

    const handCloseDw = () => {
        setOpenSearchMdl(false);
    };

    const changAutos = (prop, newValue) => {
        setValueAutos({ ...valueAutos, [prop]: newValue })
        setParams({
            ...params,
            branch: newValue.id
        });
        reloadGets(newValue, true);
        setPrevent(false);
    };

    const onChangeAuto = (prop, newValue) => {

        if (prop === "emp") {
            setValueAutos({ ...valueAutos, [prop]: newValue })
            let totSalary = Number(newValue.salary_basic);
            let addSalry = Number(params.salary_add);
            let desc = Number(params.salary_sub);
            let newSalary = parseFloat((totSalary + addSalry) - desc).toFixed(2);

            let total_salary = Number(newValue?.salary_basic) + Number(newValue?.salary_add) +
                Number(newValue?.house) + Number(newValue?.food) +
                Number(newValue?.travel) + Number(newValue?.medical) + Number(newValue?.salary_other);

            setParams({ ...params, [prop]: newValue.id, tot_salary: total_salary, salary_net: total_salary, salary_prof: total_salary });
            //---------------salary_data----------------

            setSalaryEmpData({
                ...salaryEmpData, house: Number(newValue?.house), salary_basic: Number(newValue?.salary_basic),
                salary_add: Number(newValue?.salary_add), food: Number(newValue?.food), travel: Number(newValue?.travel),
                medical: Number(newValue?.medical), salary_other: Number(newValue?.salary_other)
            });
            viewAdvances(newValue);
        } else if (prop === "branch") {
            setValueAutos({ ...valueAutos, [prop]: newValue });
            setParams({ ...params, [prop]: newValue.id });
            setBranch(newValue);
        }
        else {
            setValueAutos({ ...valueAutos, [prop]: newValue });
            setParams({ ...params, [prop]: newValue.id });
        }

    };

    const onChangeData = (prop) => (e) => {
        let i = {
            res: Number(e.target.value),
            salary_basic: Number(salaryEmpData.salary_basic),
            house: Number(salaryEmpData.house),
            food: Number(salaryEmpData.food),
            travel: Number(salaryEmpData.travel),
            medical: Number(salaryEmpData.medical),
            salary_other: Number(salaryEmpData.salary_other),
            salary_add: Number(salaryEmpData.salary_add),
            parmAdd: Number(params.salary_add),
        };
        let desc = Number(params.salary_sub);

        if (prop === "salary_basic") {
            let total_salary = i?.res + i?.house + i?.food + i?.travel + i?.medical + i?.salary_other ;
            // let total_salary = i?.res + i?.house + i?.food + i?.travel + i?.medical + i?.salary_other + i.salary_add;
         
            setParams({ ...params, tot_salary: total_salary, });
        } else if (prop === "house") {
            let total_salary = i?.salary_basic + i?.res + i?.food + i?.travel + i?.medical + i?.salary_other ;
            let net_salary = total_salary - desc;
            setParams({ ...params, tot_salary: total_salary, });
        } else if (prop === "food") {
            let total_salary = i?.salary_basic + i?.house + i?.res + i?.travel + i?.medical + i?.salary_other ;
            let net_salary = total_salary - desc;
            setParams({ ...params, tot_salary: total_salary, });
        } else if (prop === "travel") {
            let total_salary = i?.salary_basic + i?.house + i?.food + i?.res + i?.medical + i?.salary_other ;
            let net_salary = total_salary - desc;
            setParams({ ...params, tot_salary: total_salary, });
        } else if (prop === "medical") {
            let total_salary = i?.salary_basic + i?.house + i?.food + i?.travel + i?.res + i?.salary_other ;
            let net_salary = total_salary - desc;
            setParams({ ...params, tot_salary: total_salary, });
        } else if (prop === "salary_other") {
            let total_salary = i?.salary_basic + i?.house + i?.food + i?.travel + i?.medical + i?.res ;
            let net_salary = total_salary - desc;
            setParams({ ...params, tot_salary: total_salary, });
        } else if (prop === "salary_add") {
            let total_salary = i?.salary_basic + i?.house + i?.food + i?.travel + i?.medical + i?.salary_other + i.res;
            let net_salary = parseFloat(total_salary - i.parmAdd).toFixed(2);
            setParams({ ...params, tot_salary: net_salary, });
        }
        setSalaryEmpData({ ...salaryEmpData, [prop]: i.res });
    };
    const onChangeSalary = (prop) => (e) => {
        let i = {
            res: Number(e.target.value),
            salary_sub: Number(params.salary_sub),
            tot_salary: Number(params.tot_salary),
            salary_add: Number(params.salary_add),
            emp_add: Number(valueAutos?.emp?.salary_add),
            advances: Number(params?.tot_advances),

        };

        if (prop === "salary_sub") {
            let newSalary = parseFloat((i.tot_salary + i.salary_add) - (i.res+i.advances)).toFixed(2);
            setParams({ ...params, [prop]: i.res, salary_net: newSalary, });

        } else if (prop === "salary_add") {
            let newSalary = parseFloat((i.tot_salary + i.res) - (i.salary_sub+i.advances)).toFixed(2);
            let new_add = i.emp_add + i.res;
            setParams({ ...params, [prop]: i.res, salary_net: newSalary, });
            setSalaryEmpData({ ...salaryEmpData, salary_add: new_add });

        } else if (prop === "tot_salary") {
            let newSalary = parseFloat((i.res + i.salary_add) - (i.salary_sub+i.advances)).toFixed(2);
            let total_no_salary = Number(salaryEmpData?.salary_add) +
                Number(salaryEmpData?.house) + Number(salaryEmpData?.food) +
                Number(salaryEmpData?.travel) + Number(salaryEmpData?.medical) +
                Number(salaryEmpData?.salary_other);

            let new_salary = parseFloat((i.res + i.salary_add) - total_no_salary).toFixed(2);
            setSalaryEmpData({ ...salaryEmpData, salary_basic: new_salary });

            setParams({ ...params, [prop]: e.target.value, salary_net: newSalary, });
        }
        else {
            setParams({ ...params, [prop]: e.target.value });
        }
    };

    const onChange = (prop) => (e) => {
        setParams({ ...params, [prop]: e.target.value });
    };

    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });

    const ButtonWitting = (prop) => {

    };
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };




    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop === "print") {print();}
            else if (prop === "save") { handNewItem(); }
            else if (prop === "delete") { handNewItem(); }
            else {
                handNewItem();
            }
        }, timr);
    };


    const newToI = (timr) => {
        setIsLoading(true);
        ButtonLoading("new");
        ButtonSuccess("new", timr);
        setPrevent(true);
    };


    const [snack, setSnack] = React.useState(insh.Snack);

    const handOSnack = (newState) => {
        setSnack({ openSnak: true, ...newState });
    };


    const reloadGets = async () => {
        const tb = {
            wait: true,
            other: true,
            parms: {
                iempid: sto.empi,
                branch: sto.branchi,
                tname: "salary",
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setParams({
                    ...datas,
                    id: res.data.other.lastid,
                });
            })
            .catch((error) => {

            });
    };
    const onClickButton = async (procId, type) => {
        const tb = {
            ButtonSearchSalary: true,
            stor: sto,
            parms: {
                tname: type,
                branch: sto.branchi,
                iprocid: procId,
                // type: IsOpen ? 11 : 10,
            },
        };
        axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setProcIdSearch(res.data?.salary_data?.id);
                if (res.data?.salary_data.id > 0) {
                    setPrevent(false);
                    onRowClicks(res.data.salary_data);
                }
            })
            .catch((error) => {
            });
    };
    const onRowClicks = (data) => {

        setParams({
            ...data,
            branch: data.branch,
            date: reFormatDate(data.date),
            id: data.id,
            update_user: sto.idi,
            update_date: moment(new Date()).format('YYYY-MM-DD'),
        });


        let res = { branch: {}, center: {}, bank: {}, stock: {}, emp: {}, emp_resp: {}, month: {}, year: {}, state: {} };
        AutoOptions.Branches.map((x) => {
            if (x.id == data.branch) res.branch = x;
        });
        AutoOptions.Employees.map((x) => {
            if (x.id == data.emp) res.emp = x;
        });
        AutoOptions.Employees.map((x) => {
            if (x.id == data.emp_resp) res.emp_resp = x;
        });
        AutoOptions.Stocks.map((x) => {
            if (x.id == data.safe_bank_id) res.stock = x;
        });
        costCenters.map((x) => {
            if (x.id == data.center) res.center = x;
        });
        months.map((x) => {
            if (x.id == data.month) res.month = x;
        });
        years.map((x) => {
            if (x.id == data.year) res.year = x;
        });
        AutoOptions.Banks.map((x) => {
            if (x.id == data.safe_bank_id) res.bank = x;
        });

        setValueAutos({
            ...valueAutos,
            center: res.center,
            branch: res.branch,
            month: res.month,
            year: res.year,
            safe_bank_id: data.type == 1 ? res.stock : res.bank,
            emp: res.emp,
            emp_resp: res.emp_resp,
        });
        setSalaryEmpData({
            ...salaryEmpData,
            house: Number(res.emp?.house),
            salary_basic: Number(res.emp?.salary_basic),
            salary_add: Number(res.emp?.salary_add),
            food: Number(res.emp?.food),
            travel: Number(res.emp?.travel),
            medical: Number(res.emp?.medical),
            salary_other: Number(res.emp?.salary_other)
        });
        setOpenSearchMdl(false);
        setPrevent(false);
        setUiElement({ ...uiElement, DeleIcon: true });
        timer.current = window.setTimeout(
            () => setUiElement({ ...uiElement, DeleIcon: true }),
            300
        );
    };

    const print = () => {

        const info = {
            data: [],
            tot: null,
            type: 1,
            title:"سند استلام راتب الموظف :    "+valueAutos.emp.name +" " +"لشهر  "+valueAutos.month.name+"   " +"سنة  "+valueAutos.year.name,
            emp: valueAutos.emp.name,
            salary_add: params.salary_add,
            salary_net: params.salary_net,
            salary_sub: params.salary_sub,
            tot_salary: params.tot_salary,
            total_advances: params.tot_advances,
            month:valueAutos.month.name,
            year:valueAutos.year.name,
            date: moment(params.date).format("YYYY-MM-DD"),
            tDate: "00:00:00",
        };
        localStorage.setItem("iInfos", JSON.stringify(info));
        his.push({ pathname: "/SalaryPrint" });
        window.location.reload(false);
    };

    const handNewItem = () => {
        reloadGets();
        setPrevent(true);
        setValueAutos(inshValueAuto);
        setSalaryEmpData(ValueSalary);
        setAddProfSalary(true);
        setIsLoading(false);
        setOpenUpdate(false);
        setOpenButtonsSearch(false);
        setProcIdSearch(0);
        setUiElement({ ...uiElement, DeleIcon: false });
        timer.current = window.setTimeout(
            () => setUiElement({ ...uiElement, DeleIcon: true }),
            300
        );
    };
    const will = () => {
        let ob = "yes";
        if (params.emp == "" || params.emp == null) {
            ob = "no";
        } else if (params.branch == "" || params.branch == null) {
            ob = "no";
        } else if (params.salary_net == "" || params.salary_net == null) {
            ob = "no";
        } else {
            ob = "yes";
        }
        return ob;
    };
    const addChangds = () => {
        params.date =
            moment(params.date).format("YYYY-MM-DD") +
            moment(new Date()).format(" h:mm A");
    };
    const addToBS = (props) => {
        let action = will();

        if (action == "yes") {
            addChangds();
            ButtonLoading("save");
            console.log("the curre data is ", params);
            setIsLoading(true);
            let total_salary = (Number(params?.tot_salary) + Number(params?.salary_add)) -
               ( Number(params?.salary_sub)+Number(params?.tot_advances));

            const model = {
                salaryPay: { ...params, salary_net: total_salary },
                addProf: addProfSalary ? 1 : 0,
                salary_prof: salaryEmpData.salary_basic,
                house: salaryEmpData.house,
                travel: salaryEmpData.travel,
                food: salaryEmpData.food,
                medical: salaryEmpData.medical,
                salary_add: salaryEmpData.salary_add,
                salary_other: salaryEmpData.salary_other,
                rest_notes: salaryEmpData.rest_notes,
                date_prof: salaryEmpData.date_prof,
                month: valueAutos.month.name,
            };
            prevent
                ? axios
                    .post(uri + "SalaryPay", model)
                    .then((res) => {
                        if (res.data) {
                            toast.success("تمت عملية الحفظ بنجاح");
                            ButtonSuccess(props, 500);

                        } else {
                            ButtonWitting("save");
                            // reloadGets(valueAutos.branch, false);
                            toast.success("تمت عملية الحفظ بنجاح");
                            ButtonSuccess(props, 1000);
                        }
                    })
                    .catch((res) => {
                        toast.error("خطا في عملية الحفظ");
                        ButtonSuccess("save", 1000);
                    })
                :
                axios
                    .put(uri + "SalaryPay", params)
                    .then((res) => {
                        toast.success("تمت عملية التعديل بنجاح");
                        ButtonWitting("save");
                        ButtonSuccess(props, 1000);

                    })
                    .catch((res) => {
                        // reloadGets(valueAutos.branch, false);
                        ButtonSuccess("save", 1000);
                        toast.error(" لم يتم عملية التعديل ");
                    });
        } else {
            //  toast.error(" لم يتم عملية التعديل ");
            alert("برجاء اكمال البيانات .........!");
        }
    };



    const deleteToI = async (e) => {
        if (params.id > 0 && prevent === false) {
            await e.preventDefault();
            setConfirmDialog({ ...confirmDialog, isOpen: false });
            ButtonLoading("delete");

            await axios.delete(uri + `SalaryPay?id=${params.id}&&branch=${params.branch}`).then(res => {
                if (res?.data > 0) {
                    toast.success("لقد تم حذف القيد بنجاح");
                    ButtonSuccess("delete", true);
                }
                else {
                    toast.error(res.data);
                    toast.error(res.data);
                    ButtonSuccess("delete", true);
                }
            }).catch(err => {
                console.log("eror", err)
                ButtonSuccess("delete", false);
                toast.error("not delete ")
            })
        }
    };

    // ==== b sd
    const [open, setOpen] = React.useState(false);

    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();
    };

    const his = useHistory();

    const classes = useStyles();
    const { t } = useTranslation(["forms", "translation"]);
    const viewAdvances = async (newValue) => {
        setAdvances([]);
        await axios
            .get(
                uri +
                `SalaryPay/SalaryAdvances?branch=${params?.branch}
       &&emp=${newValue.id}
        &&month=${params?.month}&&year=${params?.year}`
            )
            .then((res) => {
                setAdvances(res.data.advancesData);
                let total_advances = res.data.advancesData?.reduce((a, v) => (a = a + v?.amount), 0).toFixed(2);
                let totSalary = Number(newValue.salary_basic);
                let addSalry = Number(params.salary_add);
                let desc = Number(params.salary_sub);
                let newSalary = parseFloat((totSalary + addSalry) - desc).toFixed(2);

                let total_salary = Number(newValue?.salary_basic)  +
                    Number(newValue?.house) + Number(newValue?.food) +
                    Number(newValue?.travel) + Number(newValue?.medical) + Number(newValue?.salary_other);

                setParams({ ...params, emp: newValue.id, tot_salary: total_salary, salary_net: total_salary,
                     salary_prof: total_salary ,tot_advances : total_advances,salary_add:newValue.salary_add});
                //---------------salary_data----------------
            })
            .catch((err) => {

                setAdvances([]);
                //setParams({...params,tot_advances:0});

            });
    };

    
    const isMobileDevice = () => {
        return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    };
    useEffect(() => {
        if (isMobileDevice()) return;

        const handleKeyDown = async (event) => {
            //  if (event.altKey && event.key ==="p"){
            if (event.key === 'F3') {
                event.preventDefault();
                if (!prevent ) return;
                addToBS("save");
            }
            
            if (event.key === 'F2') {
                event.preventDefault();
                await newToI(1000);
            }
            if (event.key === 'F7') {
                event.preventDefault();
                if (prevent) {
                    addToBS("print");
                } else {
                    if (openUpdate) {
                        addToBS("print");
                    } else {
                        print();
                    }
                }
            }
             if (event.key === 'F4') {
                event.preventDefault();
                if (!prevent) {
                    setOpenUpdate(true);
                }
            }
            if (event.key === 'F6') {
                event.preventDefault();
                if (!prevent) {
                    setConfirmDialog({
                        isOpen: true,
                        onConfirm: () => {
                            deleteToI(event, params.id, setting.screen);
                        },
                    })
                }

            }
            if (event.key === 'F9') {
                event.preventDefault();
                setOpenSearchMdl(true);
            }
            if (event.key === 'F8') {
                event.preventDefault();
                back();
            }
             if (event.key === 'F11') {
                event.preventDefault();
                setOpenButtonsSearch(true);
            }
            if (event.key === 'Escape') {
                event.preventDefault();
                backHome();

            }
           

        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };

    }, [params, prevent, confirmDialog, openSearchMdl, setting,confirmDialog,salaryEmpData ]);

    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    color="primary"
                    style={{ fontSize: "1.2rem", fontWeight: "bold" }}
                >
                    {"سند تسليم راتب الموظفين"}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr", backgroundColor: "#fff" }}
            >

                <Grid container
                    justifyContent="space-around"
                >
                    <Grid item lg={8} md={8} sm={12}
                        style={{ marginTop: "1rem" }}>
                        <Container
                            component={Paper}
                            maxWidth={true}
                            style={{
                                paddingTop: "0px",
                                borderColor: "#4a82b9",
                                borderTopWidth: "10px",
                                borderLeftWidth: "0px",
                                borderBottomWidth: "0px",
                                borderRightWidth: "10px",
                                borderStyle: "solid",
                            }}
                        >
                            <Grid container justify="space-between"
                                style={{ paddingBottom: '20px', marginTop: "1rem" }}>
                                <Grid item>
                                    <Chip
                                        size="large"
                                        className={clashd.ChipHdUser}
                                        style={{ fontSize: "1.3rem", fontWeight: "bold" }}
                                        label={"بيانات سند تسليم راتب الموظف"}
                                    />
                                </Grid>

                                <Grid item>
                                    <Avatar className={classes.avatar}>
                                        <AttachMoneyIcon className={classes.icon} />
                                    </Avatar>
                                </Grid>
                            </Grid>

                            <EmployeesSalaryForm
                                {...{
                                    AutoOptions,
                                    params,
                                    valueAutos,
                                    years,
                                    months,
                                    onChange,
                                    onChangeAuto,
                                    setParams,
                                    setValueAutos,
                                    addProfSalary,
                                    setAddProfSalary,
                                    branch,
                                    salaryEmpData,
                                    onChangeData,
                                    costCenters,
                                    onChangeSalary,
                                    advances,
                                    prevent
                                }}
                            />
                        </Container>
                    </Grid>

                    <Grid item lg={3} md={3} sm={12}>
                        <Container component={Paper} maxWidth={true}
                            style={{
                                padding: '10px',
                                paddingTop: '0px',
                                borderColor: "#4a82b9",
                                borderTopWidth: '0px',
                                borderLeftWidth: '0px',
                                borderBottomWidth: '0px',
                                borderRightWidth: '0px',
                                borderStyle: 'solid'
                            }}
                        >
                            <Grid
                                container
                                justify="center"
                                style={{ paddingBottom: '20px', marginTop: "1rem" }}
                            >
                                <Grid item>
                                    <Chip size="large" style={{ fontSize: "1.1rem", fontWeight: "bold" }} className={clashd.ChipHdUser} label={"مستحقات الموظف المراد اثباها"} />
                                </Grid>
                            </Grid>

                            <EmployeesSalaryProfment
                                {...{
                                    salaryEmpData,
                                    onChangeData,
                                    onChangeSalary,
                                    params
                                }}
                            />

                        </Container>
                    </Grid>
                </Grid>



            </Typography>
            <EmployeesSalaryAppbar {...{
                params,
                buttonClassnameNew,
                buttonClassnameSave,
                buttonClassnameDelete,
                clasCAB,
                newToI,
                setting,
                deleteToI,
                addToBS,
                loading,
                clasBA,
                backHome,
                back,
                uiElement,
                prevent,
                setOpenSearchMdl,
                isLoading,
                setConfirmDialog,
                setOpenUpdate,
                openUpdate,
                print,
                openButtonsSearch,
                onClickButton,
                procIdSearch,
                setOpenButtonsSearch
            }}
            />
            <EmployeeSalarySearch
                {...{
                    openSearchMdl, handCloseDw,
                    onRowClicks, AutoOptions, transition, months, IsSalary: true, costCenters
                }}
            />
              <DeleteConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
        </div>
    );
}
